import type { ValueOf } from '@kc-console/core';

export const KeyValuePairKeySizeSet = ['sm', 'md', 'lg'] as const;
export type KeyValuePairKeySize = ValueOf<typeof KeyValuePairKeySizeSet>;
export const KeyValuePairKeyWidthMap = {
  sm: 80,
  md: 140,
  lg: 200,
} as const;

export const KeyValuePairRowHeightSet = ['sm', 'md'] as const;
export type KeyValuePairRowHeight = ValueOf<typeof KeyValuePairRowHeightSet>;

export const KeyValuePairItemLabelPositionSet = ['top', 'left'] as const;
export type KeyValuePairItemLabelPosition = ValueOf<typeof KeyValuePairItemLabelPositionSet>;

export const KeyValuePairItemAlignSet = ['baseline', 'flex-start', 'center', 'stretch'] as const;
export type KeyValuePairItemAlign = ValueOf<typeof KeyValuePairItemAlignSet>;

const LABEL_MIN_WIDTH = 160;
const VALUE_MIN_WIDTH = 244;
const KEY_VALUE_PAIR_GAP = 16;
const COLUMN_GAP = 32;
const ROW_GAP = 12;

export const KeyValuePairSize = {
  LABEL_MIN_WIDTH,
  VALUE_MIN_WIDTH,
  COLUMN_GAP,
  ROW_GAP,
  COLUMN_MIN_WIDTH: LABEL_MIN_WIDTH + KEY_VALUE_PAIR_GAP + VALUE_MIN_WIDTH, // Key Value Pair 컬럼 최소 너비 (420px)
} as const;
